export function validateDateTimeForOrdersInTrip(orders, tripEtd, tripEta) {
	let orderErrors = orders.map(order => validateDateTimeForSingleOrderInTrip(order, tripEtd, tripEta));
	return {
		orders: orderErrors,
		isInvalid: orderErrors.reduce((acc, order) => acc || order.isInvalid ,false),
	};
}

function validateDateTimeForSingleOrderInTrip(order, tripEtd, tripEta) {
	if (
		!order
		|| !order.etd
		|| !order.etd.date
		|| !order.eta
		|| !order.eta.date
		|| !tripEtd
		|| !tripEtd.date
		|| !tripEta
		|| !tripEta.date
	) {
		return { // If any date is missing we'll just accept it as it is.
			orderStartsTooLate: false,
			orderEndsTooSoon: false,
			isInvalid: false,
		};
	}
	let orderStartsTooLate = (Number(tripEta.date.slice(0,8)) < Number(order.etd.date.slice(0,8)));
	let orderEndsTooSoon = (Number(order.eta.date.slice(0,8)) < Number(tripEtd.date.slice(0,8)));
	return {
		orderStartsTooLate,
		orderEndsTooSoon,
		isInvalid: orderStartsTooLate || orderEndsTooSoon,
	};
}